import { useEffect } from 'react';
import { useBackroute } from '../contexts/BackrouteContext';

/**
 * Hook for child components to easily set backroute information
 * This hook will automatically update the layout when the component mounts
 * and clean up when it unmounts
 */
export const useSetBackroute = ({
  path = null,
  title = null,
  customHandler = null
}) => {
  const { updateBackroute, resetBackroute } = useBackroute();

  useEffect(() => {
    // Set the backroute information when component mounts
    if (path || title || customHandler) {
      updateBackroute({ path, title, customHandler });
    }

    // Clean up when component unmounts
    return () => {
      resetBackroute();
    };
  }, [path, title, customHandler, updateBackroute, resetBackroute]);

  // Return the update function so components can change it dynamically if needed
  return { updateBackroute, resetBackroute };
};

/**
 * Alternative hook for components that need more control over when to update
 * This doesn't automatically set/reset on mount/unmount
 */
export const useBackrouteControl = () => {
  const { updateBackroute, resetBackroute, backroute, title, customBackHandler } = useBackroute();
  
  return {
    updateBackroute,
    resetBackroute,
    currentBackroute: backroute,
    currentTitle: title,
    currentCustomHandler: customBackHandler
  };
};